import { Routes } from '@angular/router';
import { AboutusComponent } from './aboutus/aboutus/aboutus.component';
import { ViewComponent } from './view/view.component';
import { BlogComponent } from './blogs/blog/blog.component';
import { BlogDetailComponent } from './blogs/blog-detail/blog-detail.component';
import { AdvanceProceduresTechniquesComponent } from './advance-procedures-techniques/advance-procedures-techniques/advance-procedures-techniques.component';
import { OvulationInductionComponent } from './treatments/ovulation-induction/ovulation-induction.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { InVitroFertilizationComponent } from './treatments/in-vitro-fertilization/in-vitro-fertilization.component';
import { IntracytoplasmicSpermInjectionComponent } from './treatments/intracytoplasmic-sperm-injection/intracytoplasmic-sperm-injection.component';
import { IntrauterineInseminationComponent } from './treatments/intrauterine-insemination/intrauterine-insemination.component';
import { RecurrentPregnancyLossComponent } from './treatments/recurrent-pregnancy-loss/recurrent-pregnancy-loss.component';
import { PreImplantationGeneticTestingComponent } from './treatments/pre-implantation-genetic-testing/pre-implantation-genetic-testing.component';
import { RecurrentImplantationFailureComponent } from './treatments/recurrent-implantation-failure/recurrent-implantation-failure.component';
import { WitnessingSystemComponent } from './treatments/witnessing-system/witnessing-system.component';
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';
import { FreezingPreservationComponent } from './freezing-preservation/freezing-preservation.component';
import { MedicalTeamComponent } from './medical-team/medical-team.component';
import { SpermRetrievalTechniquesComponent } from './sperm-retrieval-techniques/sperm-retrieval-techniques.component';
import { FetalMedicineScansComponent } from './fetal-medicine/fetal-medicine-scans/fetal-medicine-scans.component';
import { AntenatalInterventionsComponent } from './fetal-medicine/antenatal-interventions/antenatal-interventions.component';
import { PrenatalScansComponent } from './fetal-medicine/prenatal-scans/prenatal-scans.component';
import { FetalTherapyComponent } from './fetal-medicine/fetal-therapy/fetal-therapy.component';
import { SitePageComponent } from './site-page/site-page.component';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
    {
    path: 'aboutus',
    component: AboutusComponent,
    data: {
      title: 'About Us',
    },
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      title: 'Contact Us',
    },
    // canActivate: [AuthGuard]
  },

    {
    path: '',
    component: ViewComponent,
    data: {
      title: 'Home',
    },
  },
   {
    path: 'page/blogs',
    component: BlogComponent,
    data: {
      title: 'Blogs',
    },
  },
  {
    path: 'blog-detail/:slug',
    component: BlogDetailComponent,
    data: {
      title: 'Blogs Details',
    },
  },
    {
    path: 'advance-procedures-techniques',
    component: AdvanceProceduresTechniquesComponent,
    data: {
      title: 'Advance Procedures Techniques',
    },
  },
  {
    path: 'ovulation_induction',
    component: OvulationInductionComponent,
    data: {
      title: 'Ovulation Induction',
    },
  },

   {
    path: 'in-vitro-fertilization',
    component: InVitroFertilizationComponent,
    data: {
      title: 'In Vitro Fertilization',
    },
  },
  {
    path: 'intracytoplasmic-sperm-injection',
    component: IntracytoplasmicSpermInjectionComponent,
    data: {
      title: 'Intracytoplasmic Sperm Injection',
    },
  },
  {
    path: 'intrauterine-insemination',
    component: IntrauterineInseminationComponent,
    data: {
      title: 'Intrauterine Insemination',
    },
  },
   {
    path: 'ovulation-induction',
    component: OvulationInductionComponent,
    data: {
      title: 'Ovulation Induction',
    },
  },
   {
    path: 'recurrent-pregnancy-loss',
    component: RecurrentPregnancyLossComponent,
    data: {
      title: 'Recurrent Pregnancy Loss',
    },
  },
  {
    path: 'pre-implantation-genetic-testing',
    component: PreImplantationGeneticTestingComponent,
    data: {
      title: 'Pre Implantation Genetic Testing',
    },
  },
  {
    path: 'recurrent-implantation-failure',
    component: RecurrentImplantationFailureComponent,
    data: {
      title: 'Recurrent Implantation Failure',
    },
  },
  {
    path: 'medical-team',
    component: MedicalTeamComponent,
    data: {
      title: 'Medical Team',
    },
  },
  {
    path: 'fertility-preservation',
    component: FreezingPreservationComponent,
    data: {
      title: 'Freezing Preservation',
    },
  },
  {
    path: 'sperm-retrieval-techniques',
    component: SpermRetrievalTechniquesComponent,
    data: {
      title: 'Sperm Retrieval Techniques',
    },
  },
  {
    path: 'advance-procedures-techniques',
    component: AdvanceProceduresTechniquesComponent,
    data: {
      title: 'Advance Procedures Techniques',
    },
  },
  {
    path: 'witnessing-system',
    component: WitnessingSystemComponent,
    data: {
      title: 'Witnessing System',
    },
  },
  {
    path: 'photo-gallery',
    component: PhotoGalleryComponent,
    data: {
      title: 'Photo Gallery',
    },
  },
  // {
  //   path: 'blogs',
  //   component: BlogComponent,
  //   data: {
  //     title: 'Blogs',
  //   },
  // },
  {
    path: 'fetal-medicine-scans',
    component: FetalMedicineScansComponent,
    data: {
      title: 'Fetal Medicine Scans',
    },
  },
  {
    path: 'antenatal-interventions',
    component: AntenatalInterventionsComponent,
    data: {
      title: 'Antenatal Interventions',
    },
  },
  {
    path: 'prenatal-scans',
    component: PrenatalScansComponent,
    data: {
      title: 'Prenatal Scans',
    },
  },
  {
    path: 'fetal-therapy',
    component: FetalTherapyComponent,
    data: {
      title: 'Fetal Therapy',
    },
  },
  {
    path: 'page/:slug',
    component: SitePageComponent
  },
   {
    path: '**',
    component: NotFoundComponent
  }
//    {
//     path: 'privacy-policy',
//     component: PrivacyPolicyComponent,
//     data: {
//       title: 'Privacy Policy',
//     },
//     // canActivate: [AuthGuard]
//   },
];
